import { MockMode } from "../types";

const GLOBAL_MOCK_MODE_KEY = "mock:globalMode";
const LEGACY_LOGIN_MOCK_MODE_KEY = "mock:loginMode";

export const getGlobalMockMode = (): MockMode => {
	const globalMode = localStorage.getItem(GLOBAL_MOCK_MODE_KEY) as MockMode | null;
	if (globalMode) {
		return globalMode;
	}

	// Fallback на старый ключ, чтобы не ломать текущий flow после обновления.
	const legacyMode = localStorage.getItem(LEGACY_LOGIN_MOCK_MODE_KEY) as MockMode | null;
	return legacyMode ?? "unauthorized";
};

export const setGlobalMockMode = (mode: MockMode): void => {
	localStorage.setItem(GLOBAL_MOCK_MODE_KEY, mode);
	localStorage.setItem(LEGACY_LOGIN_MOCK_MODE_KEY, mode);
};

